import {
  DesignToken,
  Modal,
  ModalPortal,
  SpacingToken,
} from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'
import { usePreventScroll } from '@/utils/browser'
import { MarkdownRender } from '@/components/MarkdownRender'
import { useClientLoadedContext } from '@/context/clientLoaded'

const contentWrapperCss = css`
  padding: 0 var(${SpacingToken.Spacing5}) var(${SpacingToken.Spacing5});
  overflow-y: auto;
`

const modalCss = css`
  max-height: 90vh;
  width: 95vw;
  max-width: 640px;
  min-width: 360px !important;
  overflow: hidden;

  ${mediaQueries.mediumScreen()} {
    max-height: 650px;
  }

  .changelog-modal-content {
    ${contentWrapperCss};
  }

  > div {
    padding: var(${SpacingToken.Spacing5}) var(${SpacingToken.Spacing7});

    &:not(:last-child) {
      border-bottom: 1px solid var(${DesignToken.BorderBasicSecondary});
    }
  }
`

interface Props {
  onClose: () => void
  changelog: string
}

const ChangelogModal = ({ onClose, changelog }: Props) => {
  const isClientLoaded = useClientLoadedContext()
  const changelogWithoutLastHr = changelog.replace(/<hr \/>$/, '')

  usePreventScroll()

  return (
    <ModalPortal zIndex={1000}>
      <Modal
        css={modalCss}
        contentClassName="changelog-modal-content"
        onClose={onClose}
        heading="Version history"
        fullSpaceContent
      >
        <MarkdownRender
          dataTest="changelog-section"
          content={changelogWithoutLastHr}
          isRawMarkdown={isClientLoaded}
        />
      </Modal>
    </ModalPortal>
  )
}

export default ChangelogModal
